import { buildUrl } from 'Util/FetchUtils';

/**
 * Logs a user out of the application by navigating to the logout endpoint.
 * @param redirect Redirect url for the user to be navigated to after the logout is completed.
 * @param clean If true then all cookies will be purged in the logout process, otherwise only login related cookies will
 * be.
 */
export function logout(redirect?: string, clean?: boolean) {
	const params: { [key: string]: string } = {};
	if (redirect) params.redirect = redirect;
	if (clean) params.clean = 'true';
	window.location.href = buildUrl('/api/authorization/logout', params);
}
